import { ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
export function phoneValidation (reg:RegExp) :ValidatorFn {
 return (control:AbstractControl):ValidationErrors | null => {
   return !reg.test(control.value) ?  {phoneError:true}:null
 }
 }
